TS.ns('WL');

WL.leasingSimulationBase = new Class({
    Extends: WL.documentBase,

    initialize: function (config) {
        var me = this;

        me.parent(config);
        var documentDetailList = me.getDomainProperty('dgLeasingDocumentDetailCollection_Property');
        var documentInsuranceList = me.getDomainProperty('dgLeasingInsuranceCollection_Property');
        var monitoredFields = ['Amount', 'Duration', 'AdvancePercent', 'AdvanceAmount', 'RezidualPercent', 'RezidualAmount', 'CommissionPercent', 'CommissionAmount', 'InterestPercent','AgreedMileage'];

        createHandler = function (fieldName) {
            var f = fieldName;
            return function (newValue) {
                me.onOfferInfoChanged(f);
            };
        };

        $.each(monitoredFields, function (idx, fieldName) {
            if (me.Document[fieldName] != undefined) {
                me.watchProperty(me.Document[fieldName], createHandler(fieldName), me);
            }
        });
        me.watchProperty(me.Document["Amount"], me._beforeAmountChanged, me, true);

        me.showInterestType = ko.computed(function () {
            if (me.Document.AdditionalInterestTypeId() === WL.Config.AdditionalInterestType.VARIABLE && me.ShowExtendedSimulation())
                return true;
            return false;
        });

        me.amountIsEnabled = ko.computed(function () {
            if (me.DocumentHasDetails != null) {
                if (me.DocumentHasDetails())
                    return false;
            }
            return true;
        });

        me.variableInterestIsVisible = ko.computed(function () {
            if (me.Document.InterestTypeId != null) {
                if (me.Document.InterestTypeId())
                    return true;
            }
            return false;
        });

        leasingExpenseList = me.getDomainProperty('dgLeasingExpenseCollection_Property');
        if (leasingExpenseList != null) {
            leasingExpenseList.getFieldByName('gcVATId_Field').Visible(false);
        }

        me.showExtendedSimulationAndHasSectionFinancingStructure = ko.computed(function () {
            if (me.ShowExtendedSimulation() && me.HasSectionFinancingStructure())
                return true;
            return false;
        });

        me.showExtendedSimulationAndVariableInterestIsVisible = ko.computed(function () {
            if (me.ShowExtendedSimulation() && me.variableInterestIsVisible())
                return true;
            return false;
        });

        me.showExtendedSimulation = ko.computed(function () {
            if (me.ShowExtendedSimulation())
                return true;
            return false;
        });

        var scheduleView = me.getDomainProperty('ScheduleView');
        if (scheduleView != null) {
            scheduleView.customiseOptions = function (options) {
                options.height = 450;
                options.scrollable = true;
            }
        }

        var scheduleCellParamView = me.getDomainProperty('ScheduleCellParamView');
        if (scheduleCellParamView != null) {
            scheduleCellParamView.customiseOptions = function (options) {
                options.height = 450;
                options.scrollable = true;
            }
        }

        me.showParamValueDecimal = ko.computed(function () {
            if (me.Document.ScheduleCellParamTypeId)
                if (me.Document.ScheduleCellParamTypeId() === 1)
                    return true;
            return false;
        });
        me.showParamValueDate = ko.computed(function () {
            if (me.Document.ScheduleCellParamTypeId)
                if (me.Document.ScheduleCellParamTypeId() === 2)
                    return true;
            return false;
        });
        me.showParamValueBool = ko.computed(function () {
            if (me.Document.ScheduleCellParamTypeId)
                if (me.Document.ScheduleCellParamTypeId() === 3)
                    return true;
            return false;
        });
        me.showParamValueString = ko.computed(function () {
            if (me.Document.ScheduleCellParamTypeId)
                if (me.Document.ScheduleCellParamTypeId() === 4)
                    return true;
            return false;
        });
        me.partnerTypeEditable = ko.computed(function () {
            if (me.Document.MasterDocumentId())
                return false;
            return true;
        });
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var warrantyList = me.getDomainProperty('dgLeasingWarrantyCollection_Property');
        var documentDetailList = me.getDomainProperty('dgLeasingDocumentDetailCollection_Property');
        var documentInsuranceList = me.getDomainProperty('dgLeasingInsuranceCollection_Property');

        if (warrantyList != null) {
            cat = warrantyList.Commands;

            cmd = new TS.domain.Command();
            cmd['Code'] = 'EditWarrantyProperties';
            cmd['Text'] = me.EditLeasingWarrantyPropertiesCommandText;
            cmd['handler'] = '_editWarrantyProperties';
            cmd['IconCode'] = 'ellipsis-v';

            if (!me.ReadOnly())
                cat.push(cmd);

            warrantyList.on('afterAdd', me.onWarrantyAdded);
            warrantyList.on('cellValueChanged', me.onWarrantyPropertyChanged);
        }

        serviceDetail = me.getDomainProperty('dgLeasingServiceDetailCollection_Property');
        if (serviceDetail != null) {
            serviceDetail.on('cellBeginEdit', me.onServiceDetailBeginEdit);
            serviceDetail.on('cellValueChanged', me.onServiceDetailInfoChanged);

            if (!me.ServiceAdjustmentPercentIsVisibile()) {
                serviceDetail.getFieldByName('gcAdjustmentPercent_Field').Visible(false);
            }
        }

        leasingExpense = me.getDomainProperty('dgLeasingExpenseCollection_Property');
        if (leasingExpense != null) {
            leasingExpense.on('cellValueChanged', me.onLeasingExpenseChanged);
            leasingExpense.on('cellBeginEdit', me.onLeasingExpenseBeginEdit);
        }

        if (documentDetailList != null) {
            cat = documentDetailList.Commands;

            cmd = new TS.domain.Command();
            cmd['Code'] = 'EditDocumentDetailProperties';
            cmd['Text'] = me.EditLeasingDocumentDetailPropertiesCommandText;
            cmd['handler'] = '_editDocumentProperties';
            cmd['IconCode'] = 'ellipsis-v';

            cat.push(cmd);

            documentDetailList.on('afterAdd', me.onDocumentDetailAdded);
            documentDetailList.on('afterDelete', me.onDocumentDetailDeleted);
            documentDetailList.on('cellValueChanged', me.onDocumentDetailListPropertyChanged);
            documentDetailList.on('cellBeginEdit', me.onDocumentDetailBeginEdit);


            documentDetailList.getFieldByName('gcItem_Field').allowInput = false;
            documentDetailList.getFieldByName('gcItem_Field').on('propertyChanged', me.onDetailItemChanged, me);

            if (me.IsDealerUser()) {
                documentDetailList.getFieldByName('gcSupplier_Field').Visible(false);
            }
            else {
                documentDetailList.getFieldByName('gcSupplierForDealers_Field').Visible(false);
            } 

            cmd = new TS.domain.Command();
            cmd['Code'] = 'ScoreAsset';
            cmd['Text'] = me.ScoreAssetCommandText;
            cmd['handler'] = '_scoreAsset';
            cmd['IconCode'] = 'ellipsis-v';

            cat.push(cmd); 

            cmd = new TS.domain.Command();
            cmd['Code'] = 'ShowScoringHistory';
            cmd['Text'] = me.ScoringHistoryCommandText;
            cmd['handler'] = '_showScoringHistory';
            cmd['IconCode'] = 'ellipsis-v';

            cat.push(cmd);
        }

        /**/
        if (documentInsuranceList != null) {
            cat = documentInsuranceList.Commands;

            cmd = new TS.domain.Command();
            cmd['Code'] = 'UpdateDocumentInsuranceQuotation';
            cmd['Text'] = me.UpdateDocumentInsuranceQuotationPropertiesCommandText;
            cmd['handler'] = '_updateDocumentInsurances';
            cmd['IconCode'] = 'ellipsis-v';

            if (!me.ReadOnly())
                cat.push(cmd);

            documentInsuranceList.on('cellValueChanged', me.onInsurancePropertyChanged);
            documentInsuranceList.on('cellBeginEdit', me.onInsuranceBeginEdit);
        }

        var contractTypeList = me.getDomainProperty('lkpContractType_Property');
        if (contractTypeList != null) {
            contractTypeList.on('selectionChanged', me.onContractTypeChanged, me);
            contractTypeList.autoSelect = true;
        }

        var scheduleTypeList = me.getDomainProperty('lkpScheduleType_Property');
        if (scheduleTypeList) {
            scheduleTypeList.autoSelect = true;
        }

        var interestTypeList = me.getDomainProperty('lkpInterestType_Property');
        if (interestTypeList) {
            interestTypeList.on('selectionChanged', me.onInterestTypeChanged, me);
            interestTypeList.autoSelect = true;
        }

        var currencyList = me.getDomainProperty('lkpCurrency_Property');
        if (currencyList) {
            currencyList.on('selectionChanged', me.onCurrencyChanged, me);
        }
    },

    onContractTypeChanged: function (newValue) {
        var me = this;

        me.onOfferInfoChanged("ContractTypeName");
    },

    onCurrencyChanged: function (newValue) {
        var me = this;

        me.Document.ExchangeRate(null);

        me.onOfferInfoChanged("CurrencyCode");
    },

    onScheduleTypeChanged: function (newValue) {
        var me = this;

        me.onOfferInfoChanged("ScheduleTypeName");
    },

    onInterestTypeChanged: function (newValue) {
        var me = this;

        me.onOfferInfoChanged("InterestTypeName");
    },

    _beforeAmountChanged: function () {
        var me = this;

        me.Document.PrevAmount = me.Document.Amount();
    },

    onWarrantyAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        e.item.CurrencyId(WL.Config.LegalCurrency.Id);
        e.item.CurrencyCode(WL.Config.LegalCurrency.Code);
        owner.performServerCommand('Dummy', true, null, null, false, true);
    },

    onServiceDetailInfoChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;

        if (e.fieldName == 'ServiceTypeId') {
            val = e.newValue;
            owner.performServerCommand('RefreshLeasingServiceType', true, { NewValue: val, rowIdx: e.rowIdx });
        }

        if (e.fieldName == 'Quantity') {
                val = e.newValue;
                owner.performServerCommand('ComputeLeasingServiceType', true, { NewValue: val, rowIdx: e.rowIdx });
        }
    },
    onServiceDetailBeginEdit: function (e) {
        var me = this,
            owner = me._Domain;

        if (e.record.ReadOnlyYN()) {
            e.preventDefault();
        }

        if (e.fieldName == 'Selected' && e.record.Mandatory()) {
            e.preventDefault();
        }

        if ((e.fieldName == 'ServiceAmount' || e.fieldName == 'ServicePercent' || e.fieldName == 'FinancedYN' || e.fieldName == 'Duration' || e.fieldName == 'FromScheduleNo' || e.fieldName == 'ToScheduleNo' || e.fieldName == 'Periodicity') && owner.ScheduleFieldsAreReadOnly()) {
            e.preventDefault();
        }
    },

    onDocumentDetailBeginEdit: function (e) {
        var me = this,
            owner = me._Domain;

        if ((e.fieldName == 'DealerId' && !owner.AllowEditDealer())) {
            e.preventDefault();
        }
    },

    onLeasingExpenseBeginEdit: function (e) {
        var me = this,
            owner = me._Domain;

        if (e.record.ReadOnlyYN && e.record.ReadOnlyYN()) {
            e.preventDefault();
        }

        if ((e.fieldName == 'CurrencyValue' || e.fieldName == 'ExpensePercent') && owner.ScheduleFieldsAreReadOnly()) {
            e.preventDefault();
        }
    },

    onLeasingExpenseChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;
        if (e.fieldName == 'ExpensePercent' || e.fieldName == 'LeasingExpenseTypeId' || e.fieldName == 'CurrencyValue') {
            owner.performServerCommand('RefreshLeasingExpense', true, { rowIdx: e.rowIdx });
        }
    },

    onOfferInfoChanged: function (fieldName) {
        var me = this;

        if (me.BlockFinancialEvents === true || me.InsideOfferInfoChanged === true || me.settingData === true)
            return;

        me.InsideOfferInfoChanged = true;

        me.performServerCommand(
            {
                cmd: 'ComputeFinancialInformation',
                submitModel: true,
                extraData: { FieldName: fieldName },
                callback: function () {
                    me.InsideOfferInfoChanged = false;
                }
            });
    },

    _setData: function (data) {
        var me = this;
        try {
            me.settingData = true;
            me.parent(data);
        }
        finally {
            me.settingData = false;
        }

    },

    onWarrantyPropertyChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;

        if (e.fieldName == 'ItemId') {
            val = e.newValue;
            if (val != null)
                owner.performServerCommand('GetItemPropertyList', true, { NewValue: val, rowIdx: e.rowIdx });
        }
    },

    onInsuranceBeginEdit: function (e) {
        var me = this,
            owner = me._Domain;

        if ((e.fieldName == 'InsuranceAmount' || e.fieldName == 'InsurancePercent') && owner.InsuranceFieldsAreReadOnly()) {
            e.preventDefault();
        }
    },

    onInsurancePropertyChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;

        if (e.fieldName == 'InsurerId') {
            if (val != null)
                owner.performServerCommand('UpdateInsurer', true, { rowIdx: e.rowIdx });
        }

        if (e.fieldName == 'InsurancePaymentId') {
            if (val != null)
                owner.performServerCommand({
                    cmd: 'UpdateDocumentInsurances',
                    submitModel: true,
                    extraData: {},
                    blockUI: false
                });
        }
    },

    onDocumentDetailListPropertyChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;

        if ((e.fieldName == 'Quantity') || (e.fieldName == 'Amount') || (e.fieldName == 'VATId')) {
            owner.performServerCommand('UpdateDetailAmounts', true, { ChangedField: e.fieldName, rowIdx: e.rowIdx });
        }
        if (e.fieldName == 'IsSecondHand') {
            owner.performServerCommand('Dummy', true, null, null, false, true);
        }
    },

    _editDocumentProperties: function () {
        var me = this;

        documentDetailList = me.getDomainProperty('dgLeasingDocumentDetailCollection_Property');

        if (documentDetailList.SelectedItem() == null) return;
        if (documentDetailList.SelectedItem().DocumentDetailId == null) return;

        me.performServerCommand({
            cmd: 'EditDocumentDetail',
            submitModel: true,
            extraData: { UID: documentDetailList.SelectedItem().UID() },
            blockUI: false
        });
    },

    _scoreAsset: function () {
        var me = this;

        documentDetailList = me.getDomainProperty('dgLeasingDocumentDetailCollection_Property');

        if (documentDetailList.SelectedItem() == null) return;
        if (documentDetailList.SelectedItem().DocumentDetailId == null) return;

        me.performServerCommand({
            cmd: 'ScoreAsset',
            submitModel: true,
            extraData: { UID: documentDetailList.SelectedItem().UID() },
            blockUI: false
        });
    },

    _showScoringHistory: function () {
        var me = this;

        documentDetailList = me.getDomainProperty('dgLeasingDocumentDetailCollection_Property');

        if (documentDetailList.SelectedItem() == null) return;
        if (documentDetailList.SelectedItem().DocumentDetailId == null) return;

        me.performServerCommand({
            cmd: 'ShowScoringHistory',
            submitModel: true,
            extraData: { UID: documentDetailList.SelectedItem().UID() },
            blockUI: false
        });
    },

    _updateDocumentInsurances: function () {
        var me = this;

        documentDetailList = me.getDomainProperty('dgLeasingInsuranceCollection_Property');

        me.performServerCommand({
            cmd: 'UpdateDocumentInsurances',
            submitModel: true,
            extraData: {},
            blockUI: false
        });
    },

    onDocumentDetailAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        e.item.IsSecondHand(false);
        e.item.Quantity(1);
        e.item.Amount(0);
        e.item.TotalAmount(0);
        e.item.TotalAmountWithVAT(0);
        e.item.FinalAmount(0);
        e.item.Supplier(owner.DefaultSupplierName());
        e.item.SupplierId(owner.DefaultSupplierId());
        e.item.Dealer(owner.DefaultDealerName());
        e.item.DealerId(owner.DefaultDealerId());

        owner.performServerCommand('UpdateDetailCollectionChanged', true, null);
    },

    onDocumentDetailDeleted: function (e) {
        var me = this,
            owner = me._getOwner();

        owner.performServerCommand('UpdateDetailCollectionChanged', true, null);
    },

    onDetailItemChanged: function (selectedRecord) {
        var me = this,
            detailList = me.getDomainProperty('dgLeasingDocumentDetailCollection_Property');

        val = selectedRecord.sender.SelectedItem().ItemId;

        if (val != null)

            setTimeout(function () {
                me.performServerCommand('GetDetailItemPropertyList', true, { NewValue: val, rowIdx: detailList.SelectedItem().UID });
            }, 0)
    }
});

WL.leasingSimulationInsurance = new Class({

    Extends: TS.domain.RepeaterEditDomain,

    hookDocument: function () {
        var me = this,
            quotationList = me.getDomainProperty('rptLeasingDocumentDetail_dgInsurers_Property'),
            cat;

        if (quotationList) {
            cat = quotationList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'RefreshQuotations';
            newCmd['Text'] = me._getOwner().InsuranceRefreshQuotationsCommandText();
            newCmd['handler'] = '_refreshQuotations';
            newCmd['IconCode'] = 'ellipsis-v';

            if (!me.ReadOnly())
                cat.push(cmd);
        }
    },

    _refreshQuotations: function () {
        var me = this,
            owner = me._getOwner();


        owner.performServerCommand('RefreshQuotations', true, { DocumentUID: me.Document.UID() });
    }
});